<template>
  <b-modal
    ref="marketplaceListModal"
    size="lg"
    dialog-class="!max-w-[705px]"
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    hide-header
  >
    <h4 class="text-center text-[20px] font-semibold mt-[16px] mb-[24px] text-black">
      Pilih Marketplace
    </h4>
    <div class="flex flex-wrap gap-[16px] mb-[24px]">
      <button
        v-for="marketplace in MARKETPLACE_LIST"
        :key="marketplace.name"
        :disabled="marketplace.disabled"
        class="group border-[1px] rounded-md p-[16px] !transition-all !duration-300 hover:!border-[#F95031] disabled:!bg-[#F5F5F5] disabled:!border-[#E2E2E2] disabled:!cursor-not-allowed"
        :class="isSelected(marketplace) ? '!border-[#F95031]' : '!border-[#E2E2E2]'"
        @click="selectMarketplace(marketplace)"
      >
        <div class="flex items-center justify-center size-[120px]">
          <img
            :src="marketplace.icon"
            :alt="marketplace.name"
            height="72px"
            width="72px"
            class="max-h-[72px] max-w-[110px] w-auto transition-all duration-300 group-disabled:grayscale group-disabled:opacity-50"
          >
        </div>
      </button>
    </div>
    <div class="flex flex-row gap-[16px]">
      <b-button
        variant="outline-primary"
        class="w-full"
        @click="handleCancel"
      >
        Batal
      </b-button>
      <b-button
        :variant="nexButtonDisabled ? 'secondary' : 'primary'"
        class="w-full !flex items-center justify-center gap-[8px]"
        :disabled="nexButtonDisabled"
        @click="handleNext"
      >
        <b-spinner
          v-if="isOnProgress"
          small
          variant="white"
        />
        Selanjutnya
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { MARKETPLACE_LIST } from './config'

export default {
  name: 'ModalMarketplaceList',
  data() {
    return {
      MARKETPLACE_LIST,
      selectedMarketplace: null,
      isOnProgress: false,
    }
  },
  computed: {
    nexButtonDisabled() {
      return !this.selectedMarketplace || this.isOnProgress
    },
  },
  methods: {
    /**
     * Show the modal marketplace list and set the initial state
     */
    show() {
      this.selectedMarketplace = null
      this.$refs.marketplaceListModal.show()
    },
    /**
     * Hide the modal marketplace list
     */
    hide() {
      this.$refs.marketplaceListModal.hide()
    },
    /**
     * Check if the marketplace is selected
     * @param {Object} marketplace - the marketplace
     * @returns {Boolean} - true if the marketplace is selected, false otherwise
     */
    isSelected(marketplace) {
      return this.selectedMarketplace === marketplace.name
    },
    /**
     * Select the marketplace
     * @param {Object} marketplace - the marketplace
     */
    selectMarketplace(marketplace) {
      this.selectedMarketplace = marketplace.name
    },
    /**
     * Handle the cancel button click
     */
    handleCancel() {
      this.hide()
    },
    /**
     * Handle the next button click
     */
    handleNext() {
      this.$emit('next', this.selectedMarketplace)
    },
    /**
     * Set the progress status, it will disable the next button and show the spinner
     */
    setOnProgress({
      isOnProgress,
    }) {
      this.isOnProgress = isOnProgress
    },
  },
}
</script>
